import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VawWorld from "@/pages/vawworld/VawWorld";
import SkillsAgent from "@/pages/SkillsAgent";
import CaseStudyRiverking from "@/pages/case-studies/CaseStudyRiverking";
import Estimator from "@/pages/estimator/Estimator";
import "@/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<VawWorld />} />
        <Route path="/estimator" element={<Estimator />} />
        <Route path="/case-study/2m-feature" element={<CaseStudyRiverking />} />
        <Route path="/skills-agent" element={<SkillsAgent />} />
        <Route path="*" element={<VawWorld />} />
      </Routes>
    </BrowserRouter>
  );
}
